import { Grid, Typography } from '@mui/material'
import { mediaSelectors } from '@/features/media/slice'
import { useAppSelector } from '@/redux/hooks'
import { Applications } from '../inputs/Applications'
import { CatDotCom } from '../inputs/CatDotCom'
import { ConfigurableSalesModel } from '../inputs/ConfigurableSalesModel'
import { CountriesOfUse } from '../inputs/CountriesOfUse'
import { CSQ } from '../inputs/CSQ'
import { Duties } from '../inputs/Duties'
import { EmissionTiers } from '../inputs/EmissionTiers'
import { EngineModels } from '../inputs/EngineModels'
import { EPSS } from '../inputs/EPSS'
import { Excitation } from '../inputs/Excitation'
import { FeatureCode } from '../inputs/FeatureCode'
import { Frequencies } from '../inputs/Frequencies'
import { FuelTypes } from '../inputs/FuelTypes'
import { GERP } from '../inputs/GERP'
import { GeneratorArrangement } from '../inputs/GeneratorArrangement'
import { PerformanceNumber } from '../inputs/PerformanceNumber'
import { PowerDotCatDotCom } from '../inputs/PowerDotCatDotCom'
import {
  RatingBhp,
  RatingBkw,
  RatingEkw,
  RatingKva,
  RatingMhp,
} from '../inputs/Ratings'
import { RevisionNumber } from '../inputs/RevisionNumber'
import { RPM } from '../inputs/RPM'
import { Sources } from '../inputs/Sources'
import { TargetRegions } from '../inputs/TargetRegions'
import { TIP } from '../inputs/TIP'
import { Voltages } from '../inputs/Voltages'

export const ProductInformation = () => {
  const platform = useAppSelector(mediaSelectors.selectPlatform)
  const isCat = platform === 'Cat'
  return (
    <Grid container spacing={1} columns={12}>
      <Grid container size={12}>
        <Grid size={{ xs: 12, lg: 12 }}>
          <Typography variant="h2">Product Information</Typography>
        </Grid>
        <Grid size={{ xs: 12, lg: 'grow' }}>
          <EngineModels />
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <PerformanceNumber />
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <RevisionNumber />
        </Grid>
        {isCat ? (
          <Grid size={{ xs: 12, lg: 'grow' }}>
            <EmissionTiers />
          </Grid>
        ) : null}
      </Grid>
      <Grid container size={12}>
        <Grid size={{ xs: 12, lg: 4 }}>
          <TargetRegions />
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Duties />
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Sources />
        </Grid>
        <Grid size={{ xs: 12, lg: 'grow' }}>
          <FuelTypes />
        </Grid>
      </Grid>
      <Grid container size={12}>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Frequencies />
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <RPM />
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Voltages />
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Applications />
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <CountriesOfUse />
        </Grid>
      </Grid>
      <Grid size={12}>
        <fieldset>
          <legend>Ratings</legend>
          <Grid container spacing={1} size={12}>
            <Grid size={{ xs: 6, lg: 'grow' }}>
              <RatingKva />
            </Grid>
            <Grid size={{ xs: 6, lg: 'grow' }}>
              <RatingBkw />
            </Grid>
            <Grid size={{ xs: 6, lg: 'grow' }}>
              <RatingBhp />
            </Grid>
            <Grid size={{ xs: 6, lg: 'grow' }}>
              <RatingEkw />
            </Grid>
            <Grid size={{ xs: 6, lg: 'grow' }}>
              <RatingMhp />
            </Grid>
          </Grid>
        </fieldset>
      </Grid>
      <Grid container size={12}>
        <Grid size={{ xs: 12, lg: 'grow' }}>
          <Excitation />
        </Grid>
        <Grid size={{ xs: 12, lg: 'grow' }}>
          <GeneratorArrangement />
        </Grid>
        {isCat ? (
          <>
            <Grid size={{ xs: 12, lg: 3 }}>
              <ConfigurableSalesModel />
            </Grid>
            <Grid size={{ xs: 12, lg: 3 }}>
              <FeatureCode />
            </Grid>
          </>
        ) : null}
      </Grid>
      {isCat ? (
        <Grid container size={12}>
          <GERP />
          <CSQ />
          <TIP />
          <EPSS />
          <CatDotCom />
          <PowerDotCatDotCom />
        </Grid>
      ) : null}
    </Grid>
  )
}
